import { render, staticRenderFns } from "./teacherinfolist.vue?vue&type=template&id=3aa19c2e&scoped=true"
import script from "./teacherinfolist.vue?vue&type=script&lang=js"
export * from "./teacherinfolist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa19c2e",
  null
  
)

export default component.exports